// extracted by mini-css-extract-plugin
export default {"paymentRadioDiv":"DeliverForYouCreateOrder_paymentRadioDiv__zlv4t","itemImg":"DeliverForYouCreateOrder_itemImg__gdvrp"};